import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AppSessions } from '../../models/app-sessions';
import { PJTokenResponse } from '../../models/pjtoken-response';

@Injectable({
    providedIn: 'root'
})
export class ProjectsAppsService {

    constructor(private http: HttpClient) { }

    getProjIOTestToken(projectId: string, id: string, bearerToken: string): Observable<PJTokenResponse> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${bearerToken}`
        });

        return this.http
            .post<PJTokenResponse>(`${environment.engtoolapi}/api/${projectId}/ProjectsApps/${id}/GetProjIOTestToken`, {}, { headers })
            .pipe(
                retry(3),
                catchError(this.handleError)
            );
    }

    getAppSessions(id: string): Observable<AppSessions> {
        return this.http
            .get<AppSessions>(`${environment.engtoolapi}/api/AppSessions/${id}`)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}` +
                `error: ${error}`);
        }
        return throwError(() => error);
    }
}
